import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApplicationUtilsService } from '@util-services';

@Directive({
  selector: '[ecertDisplay]',
  standalone: false,
})
export class EcertDisplayDirective implements OnInit, OnDestroy {
  private display = false;
  private hasView = false;
  private curEl;
  private infoText;
  private icon;
  private informationIcon;
  private clearInformationIcon;
  private divElement;
  private parentNode;
  private subscriptions: Subscription[] = [];
  private helpIcon = 'assets/icons/ui-help.svg';
  private helpIconHoverFocus = 'assets/icons/ui-help-hover-focus.svg';

  @Input('ecertDisplay') action_handle: string;
  @Input('ecertDisplayId') id = '';
  @Input('ecertDisplayIconX') iconX = ''; // Verplaats het informatie-icon in horizontale positie
  @Input('ecertDisplayIconY') iconY = ''; // Verplaats het informatie-icon in verticale positie
  @Input('ecertDisplayTextX') textX = ''; // Voeg een marge toe aan de rechterkant van de informatie-tekst
  @Input('ecertDisplayTextY') textY = ''; // Verplaats de informatie-tekst in verticale positie

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private appUtils: ApplicationUtilsService,
    private el: ElementRef,
    private renderer: Renderer2,
    private informationIconRenderer: Renderer2,
    private informationTextRenderer: Renderer2,
    private clearInformationIconRenderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (this.appUtils.getBeheermodus()) {
      this.addIcon();
    }

    /* Er is nog geen EcertDisplay nodig in deze applicatie */
    /*
    const subscription = this.appUtils.getVeldenMappenObservable().subscribe(() => {
      this.display = !this.appUtils.getKolomActie(this.action_handle, 'verbergen');
      if (this.display && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        if (this.action_handle != undefined) {
          const spanChild = document.createElement('span');
          spanChild.setAttribute('data-identifier', this.action_handle);
          this.el.nativeElement.parentNode.appendChild(spanChild);
          this.addInformationCheck();
        }
        this.hasView = true;
      } else if (!this.display && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
    this.subscriptions.push(subscription);
    */
  }

  addIcon() {
    this.icon = document.createElement('img');
    this.icon.setAttribute('src', 'assets/icons/ui-copy-to-clipboard.svg');
    this.icon.addEventListener('click', this.copyToClipboard.bind(this));
    this.renderer.setStyle(this.icon, 'width', '18px');
    this.renderer.setStyle(this.icon, 'height', '18px');
    this.renderer.setStyle(this.icon, 'position', 'absolute');
    this.renderer.setStyle(this.icon, 'top', '1em');
    this.renderer.setStyle(this.icon, 'right', '1em');
    this.renderer.setStyle(this.icon, 'z-index', '500');
    this.renderer.setStyle(this.icon, 'cursor', 'pointer');

    const parentNode = this.el.nativeElement.parentNode;
    parentNode.insertBefore(this.icon, parentNode.firstChild);
  }

  addInformationCheck() {
    if (this.action_handle != undefined) {
      const actionIdentifierObject = this.appUtils.getActionIdentifierObject(this.action_handle);
      if (actionIdentifierObject != undefined) {
        this.infoText = actionIdentifierObject.informatie;
        if (this.infoText != null && !this.appUtils.verborgenVelden[this.action_handle] == true) {
          this.addInformationIcon();
        }
      }
    }
  }

  addInformationIcon() {
    this.informationIcon = document.createElement('img');
    this.informationIcon.setAttribute('src', this.helpIcon);
    this.informationIcon.addEventListener('click', this.toggleInformation.bind(this));
    this.curEl = document.getElementById(this.id);

    if (this.curEl != null) {
      const hasUiHelp = this.curEl.querySelectorAll(`img[src*='${this.helpIcon}']`).length > 0;
      if (!hasUiHelp) {
        this.informationIconRenderer.setStyle(this.informationIcon, 'width', '26px');
        this.informationIconRenderer.setStyle(this.informationIcon, 'height', '26px');
        this.informationIconRenderer.setStyle(this.informationIcon, 'position', 'relative');
        this.informationIconRenderer.setStyle(this.informationIcon, 'z-index', '1');
        this.informationIconRenderer.setStyle(this.informationIcon, 'cursor', 'pointer');
        this.informationIconRenderer.setStyle(this.informationIcon, 'float', 'right');

        // Verplaats het informatie-icon in horizontale positie via een variabele
        if (this.iconX !== '') {
          this.informationIconRenderer.setStyle(this.informationIcon, 'left', this.iconX);
        }
        // Verplaats het informatie-icon in verticale positie via een variabele
        if (this.iconY !== '') {
          this.informationIconRenderer.setStyle(this.informationIcon, 'top', this.iconY);
        }

        this.curEl.insertAdjacentElement('afterbegin', this.informationIcon);
        this.informationIcon.addEventListener('mouseover', this.mouseOverInformationIcon.bind(this));
        this.informationIcon.addEventListener('mouseout', this.mouseOutInformationIcon.bind(this));
      }
    }
  }

  mouseOverInformationIcon() {
    this.informationIcon.setAttribute('src', this.helpIconHoverFocus);
  }

  mouseOutInformationIcon() {
    this.informationIcon.setAttribute('src', this.helpIcon);
  }

  toggleInformation() {
    if (this.curEl.contains(this.divElement)) {
      this.deleteInformation();
    } else {
      // Blauw kruisje toevoegen om de informatie weer te kunnen verwijderen
      this.clearInformationIcon = document.createElement('img');
      this.clearInformationIcon.setAttribute('src', 'assets/icons/ui-order-withdraw.svg');
      this.clearInformationIcon.addEventListener('click', this.deleteInformation.bind(this));

      this.clearInformationIconRenderer.setStyle(this.clearInformationIcon, 'position', 'absolute');
      this.clearInformationIconRenderer.setStyle(this.clearInformationIcon, 'width', '16px');
      this.clearInformationIconRenderer.setStyle(this.clearInformationIcon, 'height', '16px');
      this.clearInformationIconRenderer.setStyle(this.clearInformationIcon, 'top', '4px');
      this.clearInformationIconRenderer.setStyle(this.clearInformationIcon, 'right', '6px');
      this.clearInformationIconRenderer.setStyle(this.clearInformationIcon, 'z-index', '1');
      this.clearInformationIconRenderer.setStyle(this.clearInformationIcon, 'cursor', 'pointer');

      // Informatie-tekst toevoegen aan div-element en deze vervolgens op het scherm tonen

      this.divElement = document.createElement('div');
      const informatie = this.appUtils.getActionIdentifierObject(this.action_handle).informatie;
      this.informationTextRenderer.setStyle(this.divElement, 'position', 'relative');

      // Maak de informatie-tekst minder breed door een marge aan de rechterkant toe te voegen via een variabele
      if (this.textX !== '') {
        this.informationTextRenderer.setStyle(this.divElement, 'margin-right', this.textX);
      }

      // Verplaats de informatie-tekst in verticale positie, via een variabele of een vaste waarde
      if (this.textY !== '') {
        this.informationTextRenderer.setStyle(this.divElement, 'top', this.textY);
      } else {
        this.informationTextRenderer.setStyle(this.divElement, 'top', '5px');
      }

      this.informationTextRenderer.setStyle(this.divElement, 'z-index', '1');
      this.informationTextRenderer.setStyle(this.divElement, 'border-style', 'dotted');
      this.informationTextRenderer.setStyle(this.divElement, 'border-width', '3px');
      this.informationTextRenderer.setStyle(this.divElement, 'padding-left', '6px');
      this.informationTextRenderer.setStyle(this.divElement, 'padding-right', '6px');
      this.informationTextRenderer.setStyle(this.divElement, 'padding-bottom', '6px');
      this.informationTextRenderer.setStyle(this.divElement, 'padding-top', '20px');
      this.informationTextRenderer.setStyle(this.divElement, 'margin-bottom', '12px');
      this.informationTextRenderer.setStyle(this.divElement, 'font-size', '1rem');
      this.informationTextRenderer.setStyle(this.divElement, 'font-weight', '300');

      this.divElement.innerHTML = informatie;
      this.divElement.appendChild(this.clearInformationIcon);
      this.curEl.insertAdjacentElement('beforeend', this.divElement);
    }
  }

  deleteInformation() {
    this.curEl.removeChild(this.divElement);
  }

  // Do not use an anonymous block in an addEventListener
  // because an anonymous block cannot be referenced when trying to remove the listener
  /*
      copyToClipboard(event) {

          document.addEventListener('copy', (e: ClipboardEvent) => {
              e.clipboardData.setData('text/plain', (this.action_handle));
              e.preventDefault();
              document.removeEventListener('copy', null);
          });
          document.execCommand('copy');
      }
  */

  // Do not use an anonymous block in an addEventListener
  // because an anonymous block cannot be referenced when trying to remove the listener
  /*
      copyToClipboard(event) {

          document.addEventListener('copy', (e: ClipboardEvent) => {
              e.clipboardData.setData('text/plain', (this.action_handle));
              e.preventDefault();
              document.removeEventListener('copy', null);
          });
          document.execCommand('copy');
      }
  */

  copyToClipboard() {
    document.addEventListener('copy', this.setDataToClipboard.bind(this));
    document.execCommand('copy');
  }

  setDataToClipboard(event) {
    event.clipboardData.setData('text/plain', this.action_handle);
    event.preventDefault();
    document.removeEventListener('copy', null);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    if (this.icon != null) {
      this.icon.removeEventListener('click', this.copyToClipboard.bind(this));
    }
    if (document != null) {
      document.removeEventListener('copy', this.setDataToClipboard.bind(this));
    }
    this.viewContainer.clear();
    this.viewContainer = null;
    this.templateRef = null;
    this.renderer = null;
    this.informationIconRenderer = null;
    this.informationTextRenderer = null;
    this.clearInformationIconRenderer = null;
    this.icon = null;
    this.informationIcon = null;
    this.clearInformationIcon = null;
    this.el = null;
  }
}
